'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  placeholder: 'Выберите время'
};
exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/~/antd/lib/time-picker/locale/ru_RU.js
// module id = 615
// module chunks = 5